// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_details {
  margin: 0 auto;
  background-color: var(--ColorPrimary);
  width: 50%;
  height: auto;
}
.box_deliveryman_details {
  display: flex;
  flex-direction: column;
}
.deliveryman_img {
  align-self: center;
}
.deliveryman_img img {
  height: 20vh;
  width: 10vw;
  border-radius: 100%;
  object-fit: contain;
  margin: 2rem;
}
.box_info_title {
  align-self: center;
  margin-left: 2rem;
  margin-top: 2rem;
}
.box_deliveryman_info {
  margin: 2rem;
  background-color: var(--ColorShadow);
  border-radius: 20px;
  border: 2px solid var(--ColorSecondaryDark);
  padding: 1rem;
}
.box_deliveryman_info text {
  display: flex;
  flex-direction: column;
  margin: 0.7rem;
}
.box_deliveryman_info span {
  font-weight: 900;
  color: var(--ColorSecondaryDark);
}
`, "",{"version":3,"sources":["webpack://./src/pages/DeliveryManDetails/deliverymandetails.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,qCAAqC;EACrC,UAAU;EACV,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gCAAgC;AAClC","sourcesContent":[".container_details {\n  margin: 0 auto;\n  background-color: var(--ColorPrimary);\n  width: 50%;\n  height: auto;\n}\n.box_deliveryman_details {\n  display: flex;\n  flex-direction: column;\n}\n.deliveryman_img {\n  align-self: center;\n}\n.deliveryman_img img {\n  height: 20vh;\n  width: 10vw;\n  border-radius: 100%;\n  object-fit: contain;\n  margin: 2rem;\n}\n.box_info_title {\n  align-self: center;\n  margin-left: 2rem;\n  margin-top: 2rem;\n}\n.box_deliveryman_info {\n  margin: 2rem;\n  background-color: var(--ColorShadow);\n  border-radius: 20px;\n  border: 2px solid var(--ColorSecondaryDark);\n  padding: 1rem;\n}\n.box_deliveryman_info text {\n  display: flex;\n  flex-direction: column;\n  margin: 0.7rem;\n}\n.box_deliveryman_info span {\n  font-weight: 900;\n  color: var(--ColorSecondaryDark);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
